import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { DealerItem } from '../../../shared/filtro-dealers/filtro-dealers.component';
import { FiltroDealers } from './filtro-dealer';
import { VeiculosPropostasFiltroService } from './veiculos-propostas-filtro.service';
import { PagamentoProposta, VeiculosPropostasService } from './veiculos-propostas.service';

@Component({
  selector: 'app-veiculos-propostas',
  templateUrl: './veiculos-propostas.component.html',
  styleUrls: ['./veiculos-propostas.component.scss']
})
export class VeiculosPropostasComponent implements OnInit, OnDestroy {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  vendaDireta = [];
  tipoDataOptions = [];
  gruposEconomicos = [];
  tipo = [];
  situacao = [];
  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];
  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  filtrosDealers: FiltroDealers;
  cargaTela: boolean;
  userDealerIds = '';
  displayPagamentos = false;
  loadingPagamentos = false;
  pagamentos: PagamentoProposta[] = [];
  valorPagamentos = 0;
  erroPagamentos = '';
  propostaSelecionada: any;
  private pagamentosSubscription: Subscription;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Code": "relatorioVeiculos.controleProposta.gridHeader.codDealer",
    "Dealer": "relatorioVeiculos.controleProposta.gridHeader.dealer",
    "Chassi": "relatorioVeiculos.controleProposta.gridHeader.chassi",
    "Número Proposta": "relatorioVeiculos.controleProposta.gridHeader.numeroProposta",
    "Modelo": "relatorioVeiculos.controleProposta.gridHeader.modelo",
    "Cor Externa": "relatorioVeiculos.controleProposta.gridHeader.corExterna",
    "Ano/Modelo": "relatorioVeiculos.controleProposta.gridHeader.anoModelo",
    "Preço de Venda": "relatorioVeiculos.controleProposta.gridHeader.precoVenda",
    "Valor dos Pagamentos": "relatorioVeiculos.controleProposta.gridHeader.valorPagamentos",
    "Emissão da Proposta": "relatorioVeiculos.controleProposta.gridHeader.emissaoProposta",
    "Situação": "relatorioVeiculos.controleProposta.gridHeader.situacao",
    "nome do Vendedor": "relatorioVeiculos.controleProposta.gridHeader.nomeVendedor",
    "Data da venda": "relatorioVeiculos.controleProposta.gridHeader.dataVenda",
    "Tipo": "relatorioVeiculos.controleProposta.gridHeader.tipo",
    "Venda Direta": "relatorioVeiculos.controleProposta.gridHeader.vendaDireta",
    "Documento": "relatorioVeiculos.controleProposta.gridHeader.documento",
    "DDD": "DDD",
    "Telefone": "relatorioVeiculos.controleProposta.gridHeader.telefone",
    "E-mail": "relatorioVeiculos.controleProposta.gridHeader.email"
  }

  constructor(private service: VeiculosPropostasService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: VeiculosPropostasFiltroService,
    private veiculosPropostas: FiltroService,
    private exportExcelSerivce: ExportExcelService,
    private router: Router,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'Controle de Propostas';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [this.dataInicial],
      data_final: [this.dataFinal],
      dealers: [''],
      grupo_economico: [''],
      chassi: [''],
      numeroProposta: [''],
      situacao: [''],
      tipo: [''],
      vendaDireta: [''],
      tipo_data: ['1']
    });
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.preencherGruposEconomicos();
    this.preencherSituacao();
    this.preencherTipo();
    this.preencherVendaDireta();
    this.preencherTipoData();

    this.loading = true;

    this.cols = [
      { field: 'dealerCode', header: 'relatorioVeiculos.controleProposta.gridHeader.codDealer', headerBr: 'Cód. Dealer', headerGb: 'Dealer Code', width: '120px' },
      { field: 'nome', header: 'relatorioVeiculos.controleProposta.gridHeader.dealer', headerBr: 'Dealer', headerGb: 'Dealer', width: '250px' },
      { field: 'chassi', header: 'relatorioVeiculos.controleProposta.gridHeader.chassi', headerBr: 'Chassi', headerGb: 'Chassis', width: '175px' },
      { field: 'numeroProposta', header: 'relatorioVeiculos.controleProposta.gridHeader.numeroProposta', headerBr: 'Número da Proposta', headerGb: 'Porposal Number', width: '140px' },
      { field: 'modelo', header: 'relatorioVeiculos.controleProposta.gridHeader.modelo', headerBr: 'Modelo', headerGb: 'Model', width: '350px' },
      { field: 'corExterna', header: 'relatorioVeiculos.controleProposta.gridHeader.corExterna', headerBr: 'Cor Externa', headerGb: 'External Color', width: '120px' },
      { field: 'anoModelo', header: 'relatorioVeiculos.controleProposta.gridHeader.anoModelo', headerBr: 'Ano/Modelo', headerGb: 'Year/Model', width: '120px' },
      { field: 'valorVenda', header: 'relatorioVeiculos.controleProposta.gridHeader.precoVenda', headerBr: 'Preço de Venda', headerGb: 'Sale Price', width: '140px' },
      { field: 'valor', header: 'relatorioVeiculos.controleProposta.gridHeader.valorPagamentos', headerBr: 'Valor dos Pagamentos', headerGb: 'Payments Amount', width: '170px' },
      { field: 'emissaoProposta', header: 'relatorioVeiculos.controleProposta.gridHeader.emissaoProposta', headerBr: 'Emissão da Proposta', headerGb: 'Issuance of the Proposal', width: '160px' },
      { field: 'situacao', header: 'relatorioVeiculos.controleProposta.gridHeader.situacao', headerBr: 'Situação', headerGb: 'Situation', width: '120px' },
      { field: 'tipo', header: 'relatorioVeiculos.controleProposta.gridHeader.tipo', headerBr: 'Tipo', headerGb: 'Type', width: '70px' },
      { field: 'vendaDireta', header: 'relatorioVeiculos.controleProposta.gridHeader.vendaDireta', headerBr: 'Venda Direta', headerGb: 'Direct Sale', width: '120px' },
      { field: 'nomeVendedor', header: 'relatorioVeiculos.controleProposta.gridHeader.nomeVendedor', headerBr: 'Nome do Vendedor', headerGb: 'Seller Name', width: '300px' },
      { field: 'dataVenda', header: 'relatorioVeiculos.controleProposta.gridHeader.dataVenda', headerBr: 'Data da Venda', headerGb: 'Sale Date', width: '160px' },
      { field: 'documento', header: 'relatorioVeiculos.controleProposta.gridHeader.documento', headerBr: 'Documento', headerGb: 'Document', width: '120px' },
      { field: 'ddd', header: 'DDD', headerBr: 'DDD', headerGb: 'DDD', width: '70px' },
      { field: 'telefone', header: 'relatorioVeiculos.controleProposta.gridHeader.telefone', headerBr: 'Telefone', headerGb: 'Telephone', width: '120px' },
      { field: 'email', header: 'relatorioVeiculos.controleProposta.gridHeader.email', headerBr: 'E-mail', headerGb: 'E-mail', width: '220px' },
    ]

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar()
      .then(() => {
        this.userDealerIds = this.filtrosDealers.idsUsuario();
      })
      .catch(() => {
        this.userDealerIds = '';
      })
      .then(() => this.getAll());
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.pagamentosSubscription) {
      this.pagamentosSubscription.unsubscribe();
    }
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherGruposEconomicos() {
    this.veiculosPropostas.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private preencherTipo() {
    this.tipo = [
      { nome: 'Usado', valor: "U" },
      { nome: 'Novo', valor: "N" }
    ];
  }

  private preencherSituacao() {
    this.situacao = [
      { nome: 'Aberto', valor: "A" },
      { nome: 'Fechado', valor: "V" },
      { nome: 'Cancelado', valor: "C" }
    ];
  }

  private preencherVendaDireta() {
    this.vendaDireta = [
      { nome: 'Sim', valor: "S" },
      { nome: 'Não', valor: "N" }
    ];
  }

  private preencherTipoData() {
    this.tipoDataOptions = [
      { name: 'Data de Proposta', value: "1" },
      { name: 'Data de Emissão Venda', value: "2" }
    ];
  }

  private getAll() {
    const di = this.f.data_inicial.value ? moment(this.f.data_inicial.value).format('DD-MM-YYYY') : '';
    const df = this.f.data_final.value ? moment(this.f.data_final.value).format('DD-MM-YYYY') : '';

    this.service.getDados(di, df, this.f.dealers.value,
      this.f.grupo_economico.value, this.f.chassi.value, this.f.numeroProposta.value, this.f.tipo.value,
      this.f.situacao.value, this.f.vendaDireta.value, this.f.tipo_data.value, this.userDealerIds).subscribe(dados => {
      this.dados = dados.dealers || [];
      this.dados.forEach(element => {
        element.vendaDireta = element.vendaDireta || 'N';
        element.valorVenda = this.formatarValorMoeda(element.valorVenda);
        element.valor = this.formatarValorMoeda(this.propostaCancelada(element) ? 0 : element.valor);
        if (element.dataVenda != null) {
          element.dataVenda = this.formatarDataVenda(element.dataVenda);
        }
      });

      this.loading = false;
      this.cargaTela = false;
    }, () => {
      this.dados = [];
      this.loading = false;
      this.cargaTela = false;
    });
  }

  public abrirPagamentos(proposta: any) {
    if (proposta?.idProposta == null) {
      this.propostaSelecionada = proposta;
      this.pagamentos = [];
      this.valorPagamentos = 0;
      this.erroPagamentos = this.translate.instant('relatorioVeiculos.controleProposta.propostaNaoEncontrada');
      this.loadingPagamentos = false;
      this.displayPagamentos = true;
      return;
    }

    if (this.pagamentosSubscription) {
      this.pagamentosSubscription.unsubscribe();
    }

    this.propostaSelecionada = proposta;
    this.pagamentos = [];
    this.valorPagamentos = 0;
    this.erroPagamentos = '';
    this.displayPagamentos = true;
    this.loadingPagamentos = true;

    this.pagamentosSubscription = this.service.getPagamentos(proposta.idProposta, this.userDealerIds)
      .subscribe(response => {
        this.pagamentos = (response?.pagamentos || []).map(pagamento => ({
          ...pagamento,
          valor: this.converterValor(pagamento.valor),
          dealer: proposta.nome || proposta.dealerCode || '',
          chassi: proposta.chassi || '',
          numeroProposta: proposta.numeroProposta
        }));
        this.valorPagamentos = this.converterValor(response?.valor);
        this.loadingPagamentos = false;
      }, (error: HttpErrorResponse) => {
        this.pagamentos = [];
        this.valorPagamentos = 0;
        this.loadingPagamentos = false;
        this.erroPagamentos = this.mensagemErroPagamentos(error);
      });
  }

  public fecharPagamentos() {
    if (!this.displayPagamentos && !this.propostaSelecionada && !this.loadingPagamentos) {
      return;
    }
    if (this.pagamentosSubscription) {
      this.pagamentosSubscription.unsubscribe();
    }
    this.displayPagamentos = false;
    this.propostaSelecionada = null;
    this.pagamentos = [];
    this.valorPagamentos = 0;
    this.erroPagamentos = '';
    this.loadingPagamentos = false;
  }

  public propostaCancelada(proposta: any): boolean {
    const situacao = String(proposta?.situacao ?? '').trim().toLowerCase();
    return situacao === 'c' || situacao.indexOf('cancel') >= 0;
  }

  public exportExcelPagamentos() {
    if (!this.pagamentos.length) {
      return;
    }

    const dealer = this.translate.instant('relatorioVeiculos.controleProposta.gridHeader.dealer');
    const chassi = this.translate.instant('relatorioVeiculos.controleProposta.gridHeader.chassi');
    const numeroProposta = this.translate.instant('relatorioVeiculos.controleProposta.gridHeader.numeroProposta');
    const tipoPagto = this.translate.instant('relatorioVeiculos.controleProposta.tipoPagto');
    const descricao = this.translate.instant('relatorioVeiculos.controleProposta.descricaoPagamento');
    const valor = this.translate.instant('relatorioVeiculos.controleProposta.valor');
    const total = this.translate.instant('relatorioVeiculos.controleProposta.totalPagamentos');

    const linhas = this.pagamentos.map(pagamento => ({
      [dealer]: pagamento.dealer || '',
      [chassi]: pagamento.chassi || '',
      [numeroProposta]: pagamento.numeroProposta ?? '',
      [tipoPagto]: pagamento.descTipoPagto || pagamento.tipoPagto || '',
      [descricao]: pagamento.descricao || '',
      [valor]: this.formatarNumero(pagamento.valor)
    }));

    linhas.push({
      [dealer]: '',
      [chassi]: '',
      [numeroProposta]: '',
      [tipoPagto]: '',
      [descricao]: total,
      [valor]: this.formatarNumero(this.valorPagamentos)
    });

    this.exportExcelSerivce.nomeModulo = 'Pagamentos da Proposta';
    this.exportExcelSerivce.ExportTOExcelJSON(linhas);
  }

  private converterValor(valor: any): number {
    const numero = valor == null || valor === '' ? 0 : Number(valor);
    return this.conversaoLibraConverte.conversaoLibra(Number.isFinite(numero) ? numero : 0, null, null);
  }

  private formatarValorMoeda(valor: any): string {
    return this.formatarNumero(this.converterValor(valor));
  }

  private formatarNumero(valor: number): string {
    return Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' })
      .format(valor || 0)
      .replace('R$', '');
  }

  private mensagemErroPagamentos(error: HttpErrorResponse): string {
    if (error?.status === 404) {
      if (typeof error.error === 'string' && error.error.trim()) {
        return error.error;
      }
      return this.translate.instant('relatorioVeiculos.controleProposta.propostaNaoEncontrada');
    }

    return this.translate.instant('relatorioVeiculos.controleProposta.erroPagamentos');
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;
    this.displayFiltros = false;

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.grupo_economico.value
      || this.f.dealer.value
      || this.f.chassi.value
      || this.f.numeroProposta.value
      || this.f.situacao.value
      || this.f.tipo.value
      || this.f.vendaDireta.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.grupo_economico.setValue('');
    this.f.chassi.setValue('');
    this.f.numeroProposta.setValue('');
    this.f.situacao.setValue('');
    this.f.tipo.setValue('');
    this.f.vendaDireta.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
    this.f.data_inicial.setValue(this.dataInicial);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
    this.f.data_final.setValue(this.dataFinal);
  }

  public onSelectDataInicial(event: Date) {
    this.dataInicial = event;
    this.f.data_inicial.setValue(event);
  }

  public onSelectDataFinal(event: Date) {
    this.dataFinal = event;
    this.f.data_final.setValue(event);
  }

  protected getTranslate(value) {
    if (value.status == 'Vendido') {
      return this.translate.currentLang == "br" ? value.status = "Vendido" : value.status = "Sold";
    }

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "relatorioVeiculos.controleProposta.gridHeader.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.dealer") {
      return "Dealer";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.numeroProposta") {
      return this.translate.currentLang == "br" ? "Número Proposta" : "Proposal Number";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.corExterna") {
      return this.translate.currentLang == "br" ? "Cor Externa" : "External Color";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.anoModelo") {
      return this.translate.currentLang == "br" ? "Ano/Modelo" : "Year/Model";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.precoVenda") {
      return this.translate.currentLang == "br" ? "Preço de Venda" : "Sale Price";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.valorPagamentos") {
      return this.translate.currentLang == "br" ? "Valor dos Pagamentos" : "Payments Amount";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.emissaoProposta") {
      return this.translate.currentLang == "br" ? "Emissão da Proposta" : "Issuance of the Proposal";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.situacao") {
      return this.translate.currentLang == "br" ? "Situação" : "Situation";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.nomeVendedor") {
      return this.translate.currentLang == "br" ? "Nome do Vendedor" : "Seller Name";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.dataVenda") {
      return this.translate.currentLang == "br" ? "Data da Venda" : "Sale Date";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.tipo") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }
if (item == "relatorioVeiculos.controleProposta.gridHeader.vendaDireta") {
  return this.translate.currentLang == "br" ? "Venda Direta" : "Direct Sale";
}

    if (item == "relatorioVeiculos.controleProposta.gridHeader.documento") {
      return this.translate.currentLang == "br" ? "Documento" : "Document";
    }
    if (item === "DDD") {
      return "DDD  ";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.telefone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Telephone";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.email") {
      return "E-mail";
    }
  }

  private translateField(item) {
    if (item == "relatorioVeiculos.veiculoVendido.statusGrid.vendido" || item == "Vendido") {
      return this.translate.currentLang == "br" ? "Vendido" : "Sold";
    }

    return item;
  }
private formatarDataVenda(valor: any): string {
  if (!valor) {
    return '';
  }

  const data = moment(valor);

  if (!data.isValid()) {
    return valor;
  }

  return data.format('DD/MM/YYYY');
}
  public exportExcel() {
    let registros = [];

    const dataInicial = this.f.data_inicial.value ? moment(this.f.data_inicial.value).format('DD-MM-YYYY') : '';
    const dataFinal = this.f.data_final.value ? moment(this.f.data_final.value).format('DD-MM-YYYY') : '';

    this.service.getDados(dataInicial, dataFinal, this.f.dealers.value,
      this.f.grupo_economico.value, this.f.chassi.value, this.f.numeroProposta.value, this.f.tipo.value,
      this.f.situacao.value, this.f.vendaDireta.value, this.f.tipo_data.value, this.userDealerIds).subscribe(dados => {
      registros = dados.dealers || [];

      registros.forEach(dados => {
        dados.vendaDireta = dados.vendaDireta || 'N';
        dados.valorVenda = this.formatarValorMoeda(dados.valorVenda);
        dados.valor = this.formatarValorMoeda(this.propostaCancelada(dados) ? 0 : dados.valor);
       
       if (dados.dataVenda != null) {
  dados.dataVenda = this.formatarDataVenda(dados.dataVenda);
}
        if (dados.emissaoProposta != null) {
          const dataEmissaoProposta = new Date(dados.emissaoProposta);
          const dataFormatadaProposta = moment(dataEmissaoProposta).format('DD/MM/YYYY HH:mm:ss');
          dados.emissaoProposta = dataFormatadaProposta;
        }
      });

      if (registros.length > 0) {
        const colunas = this._selectedColumns.filter(c => c.field != 'detalhe');
        if (!colunas.some(c => c.field === 'valor')) {
          const colunaValor = this.cols.find(c => c.field === 'valor');
          if (colunaValor) {
            colunas.push(colunaValor);
          }
        }

        this.exportExcelSerivce.nomeModulo = this.nomeModulo;
        this.exportExcelSerivce.ExportTOExcelJSON(registros.map(r => {
          const linha = {};

          colunas.forEach(c => {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          });

          return linha;
        }));
      }
    });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

}
